<template>
  <div>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular class="pa-8" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="painter" style="word-break: break-word; position: relative">
      <div v-if="!readonly" style="position: absolute; right: 1px; top: 1px">
        <v-btn @click="close" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div>
        <v-layout row wrap>
          <v-flex sm4>
            <div style="padding: 23px">
              <v-img
                style="border-radius: 10px"
                :src="
                  painter.painter_profile
                    ? painter.painter_profile
                    : '/static/img/empty-img-placeholder.png'
                "
              ></v-img>
            </div>
            <div class="text-xs-center mt-2">
              <star-rating
                :inline="true"
                :rating="
                  painter.painter_average_review ? parseFloat(painter.painter_average_review) : 0
                "
                :read-only="true"
                :rounded-corners="true"
                :star-size="18"
                :increment="0.1"
              ></star-rating>
            </div>
          </v-flex>
          <v-flex sm8>
            <div style="padding: 23px">
              <div class="caption">ชื่อ</div>
              <div style="font-weight: bold">
                {{ painter.painter_name ? painter.painter_name : '-' }}
              </div>
              <div class="caption mt-2">ที่อยู่</div>
              <div style="font-weight: bold">
                {{ painter.address ? painter.address.replace(',.', ' ') : '-' }}
              </div>
              <div class="caption mt-2">อีเมล์</div>
              <div style="font-weight: bold">
                {{ painter.painter_email ? painter.painter_email : '-' }}
              </div>
              <div class="caption mt-2">เบอร์โทรศัพท์</div>
              <div style="font-weight: bold">
                {{ painter.painter_phoneno ? painter.painter_phoneno : '-' }}
              </div>
              <div v-if="!readonly" class="mt-3">
                <multiselect
                  :data-vv-as="$t('Painter Status')"
                  v-validate="'required'"
                  name="Painter Status"
                  :searchable="false"
                  :disabled="changestatusloading"
                  color="primary"
                  @input="changeStatusPainter"
                  v-model="input.painter_status"
                  :options="['none', 'waiting for approval', 'approve']"
                  placeholder="Painter Status"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <div :style="`color: ${toatstatuscolor(props.option)}`" class="option__desc">
                      {{ props.option }}
                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div :style="`color: ${toatstatuscolor(props.option)}`" class="option__desc">
                      {{ props.option }}
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-divider v-if="transaction && transaction.length" class="my-2"></v-divider>
      <div style="max-height: 420px; overflow: auto">
        <div class="px-2">
          <div
            style="border: 0.5px solid #e2e2e2; border-radius: 6px"
            v-for="(item, k) in transaction"
            class="my-2"
            :key="k"
          >
            <v-card-text class="pb-0">
              <div :style="`font-weight: bold;color: ${$vuetify.theme.primary};`">
                {{ item.status }}
              </div>
              <div>
                ชื่อ :
                <span style="font-weight: bold"
                  >{{ item.job_details.first_name }} {{ item.job_details.last_name }}</span
                >
              </div>
              <div>
                ประเภทงาน :
                <span style="font-weight: bold">{{ item.job_details.work_type }}</span>
              </div>
              <div>
                พื้นที่ทำงาน :
                <span style="font-weight: bold">{{ item.job_details.work_area }}</span>
              </div>
              <div>
                สถานที่ :
                <span style="font-weight: bold">{{
                  item.job_details.address1 +
                  ' ' +
                  item.job_details.sub_district +
                  ' ' +
                  item.job_details.district +
                  ' ' +
                  item.job_details.province +
                  ' ' +
                  item.job_details.zip_code
                }}</span>
              </div>
            </v-card-text>
            <template v-if="expand == k">
              <v-divider class="my-2"></v-divider>
              <v-card-text class="pb-0 pt-0" style="font-size: 13px">
                <div class="px-3">
                  <v-layout row wrap>
                    <v-flex style="padding-top: 5px" xs3>การให้บริการรวดเร็ว :</v-flex>
                    <v-flex xs9>
                      <star-rating
                        :inline="true"
                        :rating="
                          item.job_details.speed_of_service
                            ? parseFloat(item.job_details.speed_of_service)
                            : 0
                        "
                        :read-only="true"
                        :rounded-corners="true"
                        :star-size="18"
                        :increment="0.1"
                      ></star-rating>
                    </v-flex>
                    <v-flex style="padding-top: 5px" xs3>การให้บริการ :</v-flex>
                    <v-flex xs9>
                      <star-rating
                        :inline="true"
                        :rating="
                          item.job_details.customer_service
                            ? parseFloat(item.job_details.customer_service)
                            : 0
                        "
                        :read-only="true"
                        :rounded-corners="true"
                        :star-size="18"
                        :increment="0.1"
                      ></star-rating>
                    </v-flex>
                    <v-flex style="padding-top: 5px" xs3>ฝีมือและความเชี่ยวชาญ :</v-flex>
                    <v-flex xs9>
                      <star-rating
                        :inline="true"
                        :rating="item.job_details.skill ? parseFloat(item.job_details.skill) : 0"
                        :read-only="true"
                        :rounded-corners="true"
                        :star-size="18"
                        :increment="0.1"
                      ></star-rating>
                    </v-flex>
                    <v-flex style="padding-top: 5px" xs3>ความคุ้มค่าของราคา :</v-flex>
                    <v-flex xs9>
                      <star-rating
                        :inline="true"
                        :rating="
                          item.job_details.worthiness ? parseFloat(item.job_details.worthiness) : 0
                        "
                        :read-only="true"
                        :rounded-corners="true"
                        :star-size="18"
                        :increment="0.1"
                      ></star-rating>
                    </v-flex>
                  </v-layout>
                  <div v-if="item.job_details.remark">
                    <div>ข้อเสนอแนะ</div>
                    <div>{{ item.job_details.remark }}</div>
                  </div>
                </div>
              </v-card-text>
            </template>

            <div
              @click="expanActive(k)"
              class="text-xs-center"
              :style="`font-size: 14px;color: ${$vuetify.theme.primary};cursor: pointer`"
            >
              <i v-if="expand == k" class="fas fa-chevron-up"></i>
              <i v-else class="fas fa-chevron-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height: 250px" class="text-xs-center">
      <div style="position: absolute; right: 1px; top: 1px">
        <v-btn @click="close" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <span style="color: grey; font-size: 23px;margin-top;125px"
        >ไม่พบข้อมูลประวัติงานของช่างทาสี</span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import multiselect from 'vue-multiselect'
import StarRating from 'vue-star-rating'

import api from '@/api'
export default {
  props: ['value', 'user', 'readonly'],
  data() {
    return {
      loading: false,
      painter: '',
      transaction: '',
      expand: null,
      changestatusloading: false,
      input: {
        painter_status: this.user.painter_status,
      },
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  components: {
    multiselect,
    StarRating,
  },
  mounted() {
    this.getData()
  },
  methods: {
    changeStatusPainter() {
      var vm = this
      vm.changestatusloading = true
      var data = {
        userid: vm.user.id,
        pageid: vm.selectedBot.pageid,
        status: vm.input.painter_status,
      }
      api.toaupdatestatuspainter(data, (err, response) => {
        vm.changestatusloading = false
        vm.$nextTick(() => {
          Object.assign(vm.value, { painter_status: vm.input.painter_status })
        })
      })
    },
    toatstatuscolor(status) {
      if (status == 'waiting for approval') return '#fb8c00'
      else if (status == 'approve') return 'green'
      else return 'rgb(201 201 201)'
    },
    expanActive(k) {
      if (this.expand == k) {
        this.expand = null
      } else {
        this.expand = k
      }
    },
    close() {
      this.$emit('close')
    },
    getData() {
      this.loading = true
      api.gettoacmspainterdetails(
        { userid: this.user.id, pageid: this.selectedBot.pageid },
        (error, response) => {
          console.log(response)
          if (response.responsecode == 200 && response.data) {
            this.painter = response.data[0]
            if (response.data2) {
              this.transaction = response.data2.map((el) => {
                return { ...el, job_details: JSON.parse(el.job_details) }
              })
            }
            this.painter.address =
              this.painter.painter_address1 +
              ' ' +
              this.painter.painter_sub_district +
              ' ' +
              this.painter.painter_district +
              ' ' +
              this.painter.painter_province +
              ' ' +
              this.painter.painter_zip_code
          }
          this.loading = false
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/ToaPainterInfo.vue